import React from 'react'
import { Edit } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'

import GenericForm from './GenericForm'

const styles = {
    card : {
        backgroundColor : '#fff',
    }
}

const EditForm = (props) => (
    <GenericForm
        inputs={props.inputs}
        schema={props.schema}
        permissions={props.permissions}
        initialValues={props.record}
        edit={true}
        // redirect="list"
        {...props}/>
)

const GenericEdit = (props) => {
    const { classes } = props
    if (props.inputs.length === 0) {
        return null
    }
    return (
        <Edit classes={classes} undoable={false} {...props}>
            <EditForm
                title={props.title}
                inputs={props.inputs}
                schema={props.schema}
                permissions={props.permissions}
            />
        </Edit>
    )
}

export default withStyles(styles)(GenericEdit)
